import React from 'react'

function Your() {
  return (
    <section className="p-3 p-md-5 text-center  transform text-light">
    <h1 className="fs-1 fw-bold" data-aos="fade-up">Ready to Transform Your Business?</h1>
    <p className="fs-5 mt-2" data-aos="fade-up">Discover how our innovative solutions and expert team can help you navigate the <br /> digital landscape and achieve your business goals.</p>
    <button className="main-btn mt-3" data-aos="fade-up">Get Started Today  <i class="bi bi-arrow-right"></i></button>
</section>
  )
}

export default Your